'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
exports.default = (0, _glamorous2.default)('a', {
  propsAreCssOverrides: true
})(function (_ref) {
  var theme = _ref.theme;
  return {
    cursor: 'pointer',
    textDecoration: theme.A_textDecoration,
    color: theme.A_color
  };
}, function (_ref2) {
  var theme = _ref2.theme;
  return {
    ':hover': {
      textDecoration: theme.A_textDecoration_hover || theme.A_textDecoration,
      color: theme.A_color_hover || theme.A_color
    }
  };
});